import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const StructureMedic = ({
  width = 14,
  height = 17,
  className,
  color,
  decorative = false,
  ariaLabel = "StructureMedic",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 14 17"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        strokeWidth="0.3"
        d="M6.86 9.777a.25.25 0 0 1-.247-.295L8.276.356A.25.25 0 0 1 8.73.262l1.398 2.095a.25.25 0 0 1 .027.225l-1.127 3.06.659.988a.25.25 0 0 1-.027.31L7.04 9.7a.25.25 0 0 1-.18.078Zm1.797-8.724L7.256 8.746 9.16 6.741l-.619-.927a.25.25 0 0 1-.026-.225l1.126-3.06z"
      />
      <path
        strokeWidth="0.3"
        d="M6.858 9.776a.25.25 0 0 1-.182-.077L4.057 6.94a.25.25 0 0 1-.027-.311l.66-.988-1.128-3.06a.25.25 0 0 1 .027-.225L4.987.262a.25.25 0 0 1 .454.094l1.662 9.126a.25.25 0 0 1-.245.294ZM4.557 6.741l1.904 2.005L5.06 1.053 4.075 2.53l1.127 3.06a.25.25 0 0 1-.026.225z"
      />
      <path
        strokeWidth="0.3"
        d="M8.52.65H5.196a.25.25 0 1 1 0-.5h3.326a.25.25 0 1 1 0 .5ZM8.212 2.336H5.5a.25.25 0 1 1 0-.5h2.712a.25.25 0 1 1 0 .5ZM13.32 13.648h-1.91a.25.25 0 1 1 0-.5h1.66V4.715a1.97 1.97 0 0 0-1.968-1.969h-1.18a.25.25 0 0 1 0-.5h1.18c.66 0 1.28.257 1.745.723.467.466.723 1.086.723 1.746v8.683a.25.25 0 0 1-.25.25ZM2.31 13.648H.398a.25.25 0 0 1-.25-.25V4.715c0-.66.257-1.28.723-1.746a2.45 2.45 0 0 1 1.746-.723h1.18a.25.25 0 0 1 0 .5h-1.18A1.97 1.97 0 0 0 .648 4.715v8.433H2.31a.25.25 0 1 1 0 .5Z"
      />
      <path
        strokeWidth="0.3"
        d="M11.409 16.15H2.313a.25.25 0 0 1-.25-.25V6.102a.25.25 0 0 1 .5 0v9.548h8.596V6.102a.25.25 0 0 1 .5 0V15.9a.25.25 0 0 1-.25.25Z"
      />
      <path
        strokeWidth="0.3"
        d="M6.86 16.151a.25.25 0 0 1-.25-.25V9.527a.25.25 0 1 1 .5 0v6.374a.25.25 0 0 1-.25.25ZM5.005 14.545h-.84a.876.876 0 0 1-.876-.875v-2.066a.25.25 0 0 1 .25-.25H5.63a.25.25 0 0 1 .25.25v2.066a.876.876 0 0 1-.875.875ZM3.79 11.854v1.816c0 .207.168.375.375.375h.841a.375.375 0 0 0 .375-.375v-1.816zM9.552 14.545h-.841a.876.876 0 0 1-.875-.875v-2.066a.25.25 0 0 1 .25-.25h2.091a.25.25 0 0 1 .25.25v2.066a.876.876 0 0 1-.875.875Zm-1.216-2.691v1.816c0 .207.168.375.375.375h.841a.375.375 0 0 0 .375-.375v-1.816z"
      />
    </svg>
  );
};
